import { definePreset } from '../types/portal-settings';

// A towing supplier sees the work assigned to them but does not create or edit
// it. The allowItem* config spelling is this portal's, and differs from the
// customer portal's allowView/allowCreate/allowEdit for the same concepts;
// carried verbatim from web-portals and worth normalising separately.
export default definePreset({
	pages: ['map', 'items', 'contacts', 'locations', 'reports', 'settings'],
	features: {
		twoFactorAuth: false,
		itemObjects: {
			enabled: true,
			allowItemView: true,
			allowItemCreation: false,
			allowItemEdit: false,
		},
		jobs: {
			enabled: true,
			fromDateDefault: 'today',
			toDateDefault: 'today',
			allowJobView: true,
			allowJobDetailsView: true,
			allowJobCreate: false,
			allowJobEdit: false,
		},
		locations: { enabled: true, allowView: true, allowCreate: false, allowEdit: false },
	},
});
